import React from 'react'
import SpainTemplateDefault from 'src/components/template/es'

const annotations = [
  {
    startSecs: '0',
    endSecs: '4',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/ve-nickelodeon-nickjr/annotations/bobesponja.png',
  },
  {
    startSecs: '4',
    endSecs: '9.6',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/ve-nickelodeon-nickjr/annotations/topwing.png',
  },
  {
    startSecs: '9.6',
    endSecs: '12.6',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/ve-nickelodeon-nickjr/annotations/unacasadelocos.png',
  },
  {
    startSecs: '12.6',
    endSecs: '16.5',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/ve-nickelodeon-nickjr/annotations/pawpatrol.png',
  },
  {
    startSecs: '15.5',
    endSecs: '21.1',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/ve-nickelodeon-nickjr/annotations/blaze.png',
  },
  {
    startSecs: '21.1',
    endSecs: '23.9',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/ve-nickelodeon-nickjr/annotations/butterbeanscafe.png',
  },
  {
    startSecs: '23.9',
    endSecs: '27',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/ve-nickelodeon-nickjr/annotations/henrydanger.png',
  },
  {
    startSecs: '27',
    endSecs: '31',
    logoUrl:
      'https://assets-imgx.fubo.tv/marketing/lp/images/es/ve-nickelodeon-nickjr/annotations/nickyrickydickydawn.png',
  },
]

const pageTitle = 'Ve Nickelodeon y Nick Jr. en Directo'
const pageDescription =
  'Disfruta de la mejor TV online. Las mejores series, dibujos infantiles de Nickelodeon y Nick Jr., realities de MTV, programas de entretenimiento para toda la familia y muchos más. En cualquier dispositivo: Ordenador, iOS, Android, Tablet…'

export default (props) => {
  return (
    <SpainTemplateDefault
      location={props.location}
      lang="es"
      market="spain"
      pageTitle={pageTitle}
      pageDescription={pageDescription}
      video="https://assets.fubo.tv/marketing/lp/videos/compressed/spain_nick_nickjr.mp4"
      title="DESDE SOLO 2,99€/mes"
      subtitle="Los mejores canales de dibujos y series infantiles"
      annotations={annotations}
      carouselTitle="DESCUBRE LO MÁS DESTACADO DE CADA CANAL"
    />
  )
}
